import { render } from "./FileWidget.vue?vue&type=template&id=4761b17b"
import script from "./FileWidget.vue?vue&type=script&lang=js"
export * from "./FileWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__